import BaseBean from "@/utils/BaseBean";

export interface IVideoTypeCardDataObj {
    utilInst:VideoTypeCardUtil
    formRef:any
    disabled:boolean
    refMap:Map<string,any>
    compParams: any
    form:any
    rules:TFormRule
    otherParams:any
}
export default class VideoTypeCardUtil extends BaseBean{
    public dataObj:IVideoTypeCardDataObj;

    constructor(proxy:any,dataObj:IVideoTypeCardDataObj) {
        super(proxy);
        this.dataObj=dataObj
    }
    //构建下拉数据
    public async buildSelectData():Promise<void>{
        //构建网点下拉数据
        //this.dataObj.networkData=await this.utils.OrderProviderApi.buildNetworkData();
    }
}